import { render, staticRenderFns } from "./allcourses.vue?vue&type=template&id=170f3f64"
import script from "./allcourses.vue?vue&type=script&lang=js"
export * from "./allcourses.vue?vue&type=script&lang=js"
import style0 from "./allcourses.vue?vue&type=style&index=0&id=170f3f64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports